// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"028aec09","453":"d8caa7b7","474":"8a8688ec","691":"5c11946b"}[chunkId] + ".chunk.js";
};